import React from "react";
import './Prevention.css';

import { renderIcon } from "../../utils";

import { Link } from "react-router-dom";



const Prevention = ({ prev }) => {

    return (

        <div className="prev-item">

            <img src={prev.image} alt={prev.title} /> {/* Prevention Image */}

            <div className="content">

                <div className='icon'>{renderIcon(prev.title)}</div> {/* Display the Prevention icon based on title */}

                {/* Link to the individual Prevention page */}
                <Link
                    to={{
                        pathname: '/Preventions/' + prev.title,  // Navigate to the specific Prevention page
                    }}
                    location = {{prev}}  // Passing Prevention details to the linked page
                    state= {prev}>
                    <h3>{prev.title}</h3> {/* Prevention Title */}
                </Link>

            </div>

        </div>
    );
};

export default Prevention;